const dunningTypes = ['estimate', 'invoice', 'proforma'];
const hydrateFormatSingleDunning = (dunning) => {
    return {
        value: dunning.value === 'id' ? +dunning.id : dunning.value,
        id: dunning.id ?? null,
        label: dunning.label ?? dunning.name,
    };
};
const hydrateFormatDunnings = (dunnings) => {
    return dunnings.map(hydrateFormatSingleDunning);
};

const persistFormatSingleDunning = (dunning) => {
    const result = {
        value: '',
    };

    switch (dunning.value) {
        case 'main':
            result.value = 'default';
            break;
        case 'disabled':
            result.value = 'disabled';
            break;
        default:
            result.value = 'id';
            result.id = dunning.value;
            break;
    }

    return result;
};
const persistFormatDunnings = (dunnings) => {
    const result = {};
    dunningTypes.forEach((type) => {
        if (dunnings[type]) {
            result[type] = persistFormatSingleDunning(dunnings[type]);
        }
    });

    return result;
};

export { dunningTypes, hydrateFormatDunnings, hydrateFormatSingleDunning, persistFormatDunnings };
